import { FC } from 'react';
import { Button } from '@components/atoms/Button';
import { Input } from '@components/atoms/Input';
import { FormGroup } from '@components/molecules/form/FormGroup';
import { useTranslation } from '@hooks/useTranslation';

type MinVersionFormProps = {
  value: string;
  description: string;
  error?: string;
  descriptionError?: string;
  touched?: boolean;
  descriptionTouched?: boolean;
  isSubmitting: boolean;
  loading: boolean;
  versionRegex: RegExp;
  settingExists: boolean;
  handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
};

export const MinVersionForm: FC<MinVersionFormProps> = ({
  value,
  description,
  error,
  descriptionError,
  touched,
  descriptionTouched,
  isSubmitting,
  loading,
  versionRegex,
  settingExists,
  handleSubmit,
  handleChange,
  handleBlur,
}) => {
  const tSettings = useTranslation('settings');
  return (
    <form className="mt-10 max-w-xl space-y-4" onSubmit={handleSubmit}>
      <div className="space-y-4">
        <FormGroup
          label={tSettings.minVersion}
          htmlFor="minVersion"
          error={touched ? (error as string) : ''}>
          <Input
            id="minVersion"
            name="minVersion"
            placeholder={tSettings.minVersionPlaceholder}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormGroup>

        <FormGroup
          label={tSettings.minVersionDescription}
          htmlFor="description"
          error={descriptionTouched ? (descriptionError as string) : ''}>
          <Input
            id="description"
            name="description"
            placeholder={tSettings.minVersionDescriptionPlaceholder}
            value={description}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormGroup>
      </div>
      <Button
        type="submit"
        loading={loading || isSubmitting}
        disabled={!versionRegex.test(value)}>
        {settingExists ? tSettings.updateMinVersion : tSettings.createMinVersion}
      </Button>
    </form>
  );
};

export default MinVersionForm;
